import * as React from 'react';
import { observer } from 'mobx-react';
import { UitkText } from 'uitk-react-text';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { FlightsConnection } from 'types/shared';

interface AdditionalInfoProps {
  flightsConnection: FlightsConnection;
  dataTestId?: string;
}

export const AdditionalInfo = observer(({ flightsConnection, dataTestId }: AdditionalInfoProps) => {
  const { duration, aircraftModel, cabinClassAndBookingCode, airlineInfo } = flightsConnection;

  return (
    <UitkLayoutFlex
      direction="column"
      space="two"
      className="all-y-padding-six all-l-padding-six"
      dataTestId={dataTestId}
    >
      <UitkLayoutFlexItem>
        <UitkText size={300} inline={true}>
          {duration}
        </UitkText>
      </UitkLayoutFlexItem>
      <UitkLayoutFlexItem>
        <UitkText size={300} inline={true}>
          {airlineInfo}
        </UitkText>
      </UitkLayoutFlexItem>
      {aircraftModel && (
        <UitkLayoutFlexItem>
          <UitkText size={300} inline={true}>
            {aircraftModel}
          </UitkText>
        </UitkLayoutFlexItem>
      )}
      <UitkLayoutFlexItem>
        <UitkText size={300} inline={true}>
          {cabinClassAndBookingCode}
        </UitkText>
      </UitkLayoutFlexItem>
    </UitkLayoutFlex>
  );
});
